import { Button } from "react-bootstrap";
import { Icon } from "semantic-ui-react";

/** Shared badge used above/below roster tables (Oracle + Docebo). */
const RosterLearnerCount = ({ count }) =>
  count > 0 && (
    <Button className="learner-count d-flex justify-content-between mb-2" type="button">
      <Icon name="user" />
      <div>{count}</div>
    </Button>
  );

export default RosterLearnerCount;
